import { createReducer } from '../../util';
import * as actions from '../actions/contractProviders';
import { StatusState } from './common';


const initialStatusState : StatusState = {
    error: false,
    errorMessage: '',
    pending: false,
};

const initialState = {
    create: {
        ...initialStatusState,
    },
    get: {
        ...initialStatusState,
    },
    update: {
        ...initialStatusState,
    },
    delete: {
        ...initialStatusState,
    },
    download: {
        ...initialStatusState,
    },
    uploadFile: {
        ...initialStatusState,
    },
    updateStatus: {
        ...initialStatusState,
    },
    search: {
        ...initialStatusState,
    },
    updateNPIRole: {
        ...initialStatusState,
    },
};

export default createReducer(initialState, {
    [actions.PROVIDERS_CREATE_PENDING]: (state) => ({
        ...state,
        create: {
            pending: true,
        },
    }),
    [actions.PROVIDERS_CREATE_FULFILLED]: (state) => ({
        ...state,
        create: {
            ...initialStatusState,
        }
    }),
    [actions.PROVIDERS_CREATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        create: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.PROVIDERS_GET_PENDING]: (state) => ({
        ...state,
        get: {
            pending: true,
        },
    }),
    [actions.PROVIDERS_GET_FULFILLED]: (state, contract) => ({
        ...state,
        get: {
            ...initialStatusState,
        },
        data: [contract]
    }),
    [actions.PROVIDERS_GET_REJECTED]: (state, errorMessage) => ({
        ...state,
        get: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.PROVIDER_UPDATE_PENDING]: (state) => ({
        ...state,
        update: {
            pending: true,
        },
    }),
    [actions.PROVIDER_UPDATE_FULFILLED]: (state) => ({
        ...state,
        update: {
            ...initialStatusState,
        }
    }),
    [actions.PROVIDER_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        update: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.DELETE_PROVIDER_PENDING]: (state) => ({
        ...state,
        delete: {
            pending: true,
        },
    }),
    [actions.DELETE_PROVIDER_FULFILLED]: (state) => ({
        ...state,
        delete: {
            ...initialStatusState,
        }
    }),
    [actions.DELETE_PROVIDER_REJECTED]: (state, errorMessage) => ({
        ...state,
        delete: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
    [actions.PROVIDER_DOWNLOAD_REPORT_PENDING]: (state) => ({
        ...state,
        download: {
            pending: true,
        },
    }),
    [actions.PROVIDER_DOWNLOAD_REPORT_FULFILLED]: (state) => ({
        ...state,
        download: {
            ...initialStatusState,
        },
    }),
    [actions.PROVIDER_DOWNLOAD_REPORT_REJECTED]: (state, errorMessage) => ({
        ...state,
        download: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.PROVIDER_UPLOAD_FILE_PENDING]: (state) => ({
        ...state,
        uploadFile: {
            pending: true,
        },
    }),
    [actions.PROVIDER_UPLOAD_FILE_FULFILLED]: (state, types) => ({
        ...state,
        uploadFile: {
            ...initialStatusState,
        },
    }),
    [actions.PROVIDER_UPLOAD_FILE_REJECTED]: (state, { errorMessage, innerException, errorDetails }) => ({
        ...state,
        uploadFile: {
            ...initialStatusState,
            error: true,
            errorMessage,
            innerException,
            errorDetails
        },
    }),

    [actions.PROVIDER_STATUS_UPDATE_PENDING]: (state) => ({
        ...state,
        updateStatus: {
            pending: true,
        },
    }),
    [actions.PROVIDER_STATUS_UPDATE_FULFILLED]: (state) => ({
        ...state,
        updateStatus: {
            ...initialStatusState,
        }
    }),
    [actions.PROVIDER_STATUS_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        updateStatus: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.PROVIDER_SEARCH_FROM_NPI_PENDING]: (state) => ({
        ...state,
        search: {
            pending: true,
        },
    }),
    [actions.PROVIDER_SEARCH_FROM_NPI_FULFILLED]: (state, data) => ({
        ...state,
        search: {
            ...initialStatusState,
        },
        data: data
    }),
    [actions.PROVIDER_SEARCH_FROM_NPI_REJECTED]: (state, errorMessage) => ({
        ...state,
        search: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.PROVIDER_UPDATE_NPI_ROLE_PENDING]: (state) => ({
        ...state,
        updateNPIRole: {
            pending: true,
        },
    }),
    [actions.PROVIDER_UPDATE_NPI_ROLE_FULFILLED]: (state) => ({
        ...state,
        updateNPIRole: {
            ...initialStatusState,
        }
    }),
    [actions.PROVIDER_UPDATE_NPI_ROLE_REJECTED]: (state, errorMessage) => ({
        ...state,
        updateNPIRole: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

});
